import {createSlice} from '@reduxjs/toolkit';
import {
    deviceAdaptAPI,
    deviceAdaptStartAPI,
    deviceAdaptPreviousStepAPI,
    deviceAdaptUpdateAPI,
    deviceAdaptResourceAPI,
    getLanguageAPI,
    deviceAdaptSearchResourceAPI
} from '../api/adaptAPI';

const initialState = {
    adaptStartError: null,
    adaptStartSuccess: null,
    languageSuccess: null,
    languageError: null,
    data: {},
    language: {}
};

export const adaptSlice = createSlice({
    name: 'register',
    initialState,
    reducers: {
        adaptStartError(state, action) {
            state.adaptStartError = action.payload
        },
        adaptStartSuccess(state, action) {
            state.data = action.payload
        },
        languageError(state, action) {
            state.languageError = action.payload
        },
        languageSuccess(state, action) {
            state.language = action.payload
        },
    },
});

export const {adaptStartError, adaptStartSuccess, languageSuccess, languageError} = adaptSlice.actions;

export const deviceAdapt = (id, callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptAPI(id)
        if (response) {
            dispatch(adaptStartSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};
export const getLanguage = (callback) => async (dispatch, getState) => {
    try {
        const response = await getLanguageAPI()
        if (response) {
            dispatch(languageSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(languageError(forgetError))
    }
};
export const deviceAdaptResource = (callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptResourceAPI()
        if (response) {
            dispatch(adaptStartSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};
export const deviceAdaptSearchResource = (deviceId, data, callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptSearchResourceAPI(deviceId, data)
        if (response) {
            dispatch(adaptStartSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};
export const deviceAdaptStart = (data, callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptStartAPI(data)
        if (response) {
            dispatch(adaptStartSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};
export const deviceAdaptUpdate = (data, callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptUpdateAPI(data)
        console.log(callback, response)
        if (callback) callback(response)
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};
export const deviceAdaptPreviousStep = (id, adaptId, callback) => async (dispatch, getState) => {
    try {
        const response = await deviceAdaptPreviousStepAPI(id, adaptId)
        if (response) {
            dispatch(adaptStartSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(adaptStartError(forgetError))
    }
};

export default adaptSlice.reducer;
